import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import EditButton from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import { NotificationManager } from "react-notifications";
import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import moment from "moment";
import DateInput from "components/Input/DateInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import {
   postMBMCampaign, putMBMCampaign, getFiles,
  getMBMEquipments, getMBMCampaignEquipments, deleteMBMCampaignEquipment,
  getMBMCampaignViews, deleteMBMCampaignView, putMBMCampaignView
} from "services/ConfigServices";
import styled from "styled-components";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { campaignequipmenttext, campaignpointtext, campaignviewtext } from "variables/MBM/campaign";
import { statusData, equipmentstatusData, equipmentinstalledData } from "variables/MBM/lists/campaign"
import { dico } from "variables/lists/dico";
import { definitionData, stateData } from "variables/MBM/lists/equipments";
import DataTable from "react-data-table-component";
import _ from "lodash";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddEquipmentToCampaign from "./AddEquipmentToCampaign";
import CustomConfirmationDialog from "components/CustomDialog/CustomConfirmationDialog";
import CustomYesNoDialog from "components/CustomDialog/CustomYesNoDialog";
import EquipmentDialog from "./EquipmentDialog";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import PointDialog from "./PointDialog";
import AddViewToCampaign from "./AddViewToCampaign";
import ViewEditionDialog from "./ViewEditionDialog";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles2 = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "13ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "13ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function CampaignEditionDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const { closeModal, refetch, setLoading, currentCampaign } = props;

  const [campaign, setCampaign] = useState(currentCampaign || {});

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [openExitConfirmation, setOpenExitConfirmation] = useState(false);
  const [generalparameterschange, setGeneralparameterschange] = useState(false);

  const [openExitConfirmationView, setOpenExitConfirmationView] = useState(false);
  const [viewstoupdate, setViewstoupdate] = useState([]);

  const [name, setName] = useState(campaign?.parameters?.general?.name || "");
  const [description, setDescription] = useState(campaign?.parameters?.general?.description || "");
  const [groups, setGroups] = useState(campaign?.parameters?.general?.groups ? "" + campaign.parameters?.general?.groups : "");
  const [datebegin, setDatebegin] = useState(campaign?.parameters?.general?.datebegin || "");
  const [dateend, setDateend] = useState(campaign?.parameters?.general?.dateend || "");
  const [incharge, setIncharge] = useState(campaign?.parameters?.general?.incharge || "");
  const [associatedfiles, setAssociatedfiles] = useState(campaign?.parameters?.general?.associatedfiles || "");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [mbmequipments, setMbmequipments] = useState([]); //all equiments for selected group


  const [equipments, setEquipments] = useState([]);
  const [points, setPoints] = useState([]);
  const [selectedequipments, setSelectedequipments] = useState([]);
  const [currentequipment, setCurrentequipment] = useState("");
  const [open, setOpen] = useState(false);
  const [currentpoint, setCurrentpoint] = useState("");
  const [openpoint, setOpenpoint] = useState(false);

  const [views, setViews] = useState([]);
  const [selectedviews, setSelectedviews] = useState([]);
  const [currentview, setCurrentview] = useState("");
  const [openview, setOpenview] = useState(false);

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const selectedDocuments = () => {
    let selected = {};
    if (associatedfiles !== undefined) {
      selected = associatedfiles;
    }
    return selected;
  };
  const handleAssociatedfilesChange = (newValue) => {
    setAssociatedfiles(newValue);
  };

  useEffect(() => {
    if (groups) {
      axios
        .get(getMBMEquipments(groups, "false"), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setMbmequipments(res.data.equipments);
        });
    }
  }, [groups]);

  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    if (campaign?.id) {
      axios
        .get(getMBMCampaignEquipments(campaign.id), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setEquipments(res.data.equipments);
          setPoints(res.data.points);
        });
    }
  }, [groups, refresh]);
  const refreshTable = () => {
    setRefresh(!refresh);
  }

  const [refreshview, setRefreshview] = useState(false);
  useEffect(() => {
    if (campaign?.id) {
      axios
        .get(getMBMCampaignViews(campaign.id), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setViews(res.data.views);
        });
    }
  }, [groups, refreshview]);
  const refreshTableView = () => {
    setRefreshview(!refreshview);
  }

  const handleNameChange = (event) => {
    setGeneralparameterschange(true);
    setName(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setGeneralparameterschange(true);
    setDescription(event.target.value);
  };
  const handleDatebeginChange = (event) => {
    setGeneralparameterschange(true);
    setDatebegin(event.target.value);
  };
  const handleDateendChange = (event) => {
    setGeneralparameterschange(true);
    setDateend(event.target.value);
    if (campaign && views) {
      views.forEach((view) => {
        if (view.parameters?.general?.dateend) {
          if (moment(view.parameters?.general?.dateend) < moment(event.target.value)) {
            setOpenExitConfirmationView(true);
          }
        }
      });
    }
  };
  const handleCloseConfirmationView = (e) => {
    setOpenExitConfirmationView(false);
  };

  const handleExitConfirmationView = (e) => {
    //faire le changemenbt
    let tmpviewstoupdate = [];
    views.forEach((view) => {
      if (view.parameters?.general?.dateend) {
        if (moment(view.parameters?.general?.dateend) < moment(dateend)) {
          let tmpview = { ...view };
          tmpview.parameters.general.dateend = dateend;
          tmpviewstoupdate.push(tmpview);
        }
      }
    });
    setViewstoupdate(tmpviewstoupdate);
    setOpenExitConfirmationView(false);
  };

  const handleInchargeChange = (event) => {
    setGeneralparameterschange(true);
    setIncharge(event.target.value);
  };
  const handleGroupsChange = (value) => {
    setGeneralparameterschange(true);
    setGroups(value);
  };

  const classes = useStyles();
  const classes2 = useStyles2();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    if (!campaign || !campaign.id) {

    }
    else {
      if (value === "0" && generalparameterschange) {
        setOpenExitConfirmation(true);
      }
      else
        setValue(newValue);
    }
  };
  const handleCloseConfirmation = (e) => {
    setOpenExitConfirmation(false);
  };

  const handleExitConfirmation = (e) => {
    setName(campaign?.parameters?.general?.name || "");
    setDescription(campaign?.parameters?.general?.description || "");
    setGroups(campaign?.parameters?.general?.groups ? "" + campaign.parameters?.general?.groups : "");
    setIncharge(campaign?.parameters?.general?.incharge || "");
    setAssociatedfiles(campaign?.parameters?.general?.associatedfiles || "");
    setViewstoupdate([]);
    setOpenExitConfirmation(false);
    setGeneralparameterschange(false);
    setValue("1");
  };


  const handleSubmit = (event) => {
    if (currentCampaign)
      updateCampaign();
    else
      createCampaign(event);
    setGeneralparameterschange(false);
  };

  useEffect(() => {
    if (!generalparameterschange || !name || !groups || groups.length === 0 || groups === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const createCampaign = async (event) => {
    const general = {
      name,
      description,
      groups,
      datebegin,
      dateend,
      status: 'pending',
      incharge,
      associatedfiles
    }
    const parameters = {
      general
    }
    axios
      .post(
        postMBMCampaign(),
        {
          parameters,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let newcampaign = {
            parameters,
            id: res.data.id
          };
          setCampaign(newcampaign);
          setNotification("success", "Campagne créée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateCampaign = async () => {
    const general = {
      ...campaign.parameters.general,
      name,
      description,
      groups,
      datebegin,
      dateend,
      incharge,
      associatedfiles
    }
    const parameters = {
      ...campaign.parameters,
      general,
      equipments
    }
    axios
      .put(
        putMBMCampaign(campaign.id),
        {
          parameters,

        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let newcampaign = {
            parameters,
            id: campaign.id
          };
          setCampaign(newcampaign);
          setNotification("success", "Campagne modifiée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
    viewstoupdate.forEach((view) => {
      const parameters = {
        ...view.parameters,
      }
      axios
        .put(
          putMBMCampaignView(view.id),
          {
            parameters,
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              "Content-Type": "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Vue modifiée");
            refetch();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          // setLoading(false);
        });
    });
  };

  const equipmentscolumns = [
    {
      name: campaignequipmenttext.name,
      selector: (row) => row.parameters.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.name
    },
    {
      name: campaignequipmenttext.campaignname,
      selector: (row) => row.parameters.campaignname,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.campaignname
    },
    {
      name: campaignequipmenttext.definition,
      selector: (row) => row.parameters.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.parameters.definition)?.name || ""
    },
    {
      name: campaignequipmenttext.installed,
      selector: (row) => row.parameters.installed,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => equipmentinstalledData.find((x) => x.id == row.parameters.installed)?.name || ""
    },
    {
      name: campaignequipmenttext.campaigngroup,
      selector: (row) => row.parameters.campaigngroup,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.parameters.campaigngroup] || ""
    },
    {
      name: campaignequipmenttext.localization,
      selector: (row) => row.parameters.localization,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters.localization
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer l'équipement'">
              <EditButton
                onClick={editCampaignEquipment(row)}
                color={"warning"}
                className={classes2.actionButton}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            {mbmadmin && (
              <Tooltip title="Supprimer l'équipement de la campagne">
                <CustomDeleteButton
                  deleteTitle={"Suppression de l'équipement"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer l'équipement '${row.parameters.name} de la campagne?`}
                  handleSupprimer={deleteEquipmentFromCampaignFunction(row)}
                />
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ]

  const pointscolumns = [
    {
      name: campaignpointtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: campaignpointtext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: campaignpointtext.unit,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => dico.find((x) => x.id == row.definition)?.unit || ""
    },
    {
      name: campaignpointtext.conversion,
      selector: (row) => row.conversion,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.conversion,
    },
    {
      name: campaignpointtext.group,
      selector: (row) => row.groupid,
      sortable: true,
      // maxWidth: "12rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>

          <div className="actions-right">
            {mbmadmin && (
              <Tooltip title="Editer le point">
                <EditButton
                  onClick={editPoint(row)}
                  color={"warning"}
                  className={classes2.actionButton}
                >
                  <EditIcon fontSize="large" />
                </EditButton>
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };
  const handleClickOpenPoint = () => {
    setOpenpoint(true);
  };
  const handleEditClosePoint = () => {
    setOpenpoint(false);
  };
  const editCampaignEquipment = (row) => async () => {
    let obj = equipments.find((o) => o.id === row.id);
    if (obj) {
      setCurrentequipment(obj);
      handleClickOpen();
    }
  }
  const editPoint = (row) => async () => {
    let obj = points.find((o) => o.id === row.id);
    let eq = equipments.find((x) => x.id == row.campaignequipmentid);
    if (obj && eq) {
      setCurrentpoint(obj);
      setCurrentequipment(eq);
      handleClickOpenPoint();
    }
  }

  const deleteEquipmentFromCampaignFunction = (row) => async () => {
    let obj = equipments.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteMBMCampaignEquipment(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'équipement a été supprimé de la campagne`
          );
          refreshTable();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = points.filter((x) => x.campaignequipmentid === data.id);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucun Point à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        />
      </Container>
    );
  };

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = equipments.filter(
    (item) =>
      (item.parameters?.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.groups && groupInfoListById["" + item.parameters.groups] && groupInfoListById["" + item.parameters.groups].toLowerCase().includes(filterText.toLowerCase()))
  );
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedequipments.map((item) => {
      let equipmenttoexport = {};
      equipmenttoexport[campaignequipmenttext.id] = item.id;
      equipmenttoexport[campaignequipmenttext.name] = item.parameters.name;
      equipmenttoexport[campaignequipmenttext.campaignname] = item.parameters.campaignname;
      equipmenttoexport[campaignequipmenttext.campaigngroup] = groupInfoListById["" + item.parameters.campaigngroup];
      equipmenttoexport[campaignequipmenttext.localization] = item.parameters.localization;
      equipmenttoexport[campaignequipmenttext.definition] = definitionData.find((x) => x.id == item.parameters.definition)?.name;
      equipmenttoexport[campaignequipmenttext.installed] = equipmentinstalledData.find((x) => x.id == item.parameters.installed)?.name;
      return equipmenttoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddEquipmentToCampaign
                onClick={handleClear}
                refetch={refreshTable}
                mbmequipments={mbmequipments}
                equipments={equipments}
                setEquipments={setEquipments}
                campaigngroup={groups}
                campaignid={campaign.id}
              />
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedequipments || selectedequipments.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, equipments, mbmequipments, selectedequipments, campaign]);

  const handleSelectedRowsChange = (selection) => {
    setSelectedequipments(selection.selectedRows);
  };


  /*VIEWS TAB*/
  const viewscolumns = [
    {
      name: campaignviewtext.name,
      selector: (row) => row.parameters.general.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.general.name
    },
    {
      name: campaignviewtext.columns,
      selector: (row) => row.parameters.general.columns,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters.general.columns
    },
    {
      name: campaignviewtext.datebegin,
      selector: (row) => row.parameters.general.datebegin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.general.datebegin && moment(row.parameters.general.datebegin).isValid()
          ? moment(row.parameters.general.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: campaignviewtext.dateend,
      selector: (row) => row.parameters.general.dateend,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.general.dateend && moment(row.parameters.general.dateend).isValid()
          ? moment(row.parameters.general.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: campaignviewtext.chartscount,
      selector: (row) => row.parameters.charts.length,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.parameters.charts.length
    },
    {
      name: campaignviewtext.groups,
      selector: (row) => row.parameters.general.groups,
      sortable: true,
      cell: (row) => groupInfoListById["" + row.parameters.general.groups] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer la vue'">
              <EditButton
                onClick={editCampaignView(row)}
                color={"warning"}
                className={classes2.actionButton}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Supprimer la vue de la campagne">
              <CustomDeleteButton
                deleteTitle={"Suppression de la vue"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la vue '${row.parameters.general.name} de la campagne?`}
                handleSupprimer={deleteViewFromCampaignFunction(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ]



  const handleClickOpenView = () => {
    setOpenview(true);
  };
  const handleEditCloseView = () => {
    setOpenview(false);
  };

  const editCampaignView = (row) => async () => {
    let obj = views.find((o) => o.id === row.id);
    if (obj) {
      setCurrentview(obj);
      handleClickOpenView();
    }
  }
  const deleteViewFromCampaignFunction = (row) => async () => {
    let obj = views.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteMBMCampaignView(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La vue a été supprimée de la campagne`
          );
          refreshTableView();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const [filterTextView, setFilterTextView] = useState("");
  const [resetPaginationToggleView, setResetPaginationToggleView] = useState(false);
  const SearchComponentView = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItemsView = views.filter(
    (item) =>
      (item.parameters?.general?.name && item.parameters.general.name.toLowerCase().includes(filterTextView.toLowerCase()))
  );
  const subHeaderComponentMemoView = useMemo(() => {
    const handleClearView = () => {
      if (filterTextView) {
        setResetPaginationToggleView(!resetPaginationToggleView);
        setFilterTextView("");
      }
    };
    const onFilterTextView = (e) => setFilterTextView(e.target.value);
    let exportarray = selectedviews.map((item) => {
      let viewtoexport = {};
      viewtoexport[campaignviewtext.id] = item.id;
      viewtoexport[campaignviewtext.name] = item.parameters.general.name;
      viewtoexport[campaignviewtext.columns] = item.parameters.general.columns;
      viewtoexport[campaignviewtext.groups] = groupInfoListById["" + item.parameters.general.groups];
      viewtoexport[campaignviewtext.datebegin] = item.parameters.general.datebegin && moment(item.parameters.general.datebegin).isValid() ? moment(item.parameters.general.datebegin).format("DD/MM/YYYY") : "";
      viewtoexport[campaignviewtext.dateend] = item.parameters.general.dateend && moment(item.parameters.general.dateend).isValid() ? moment(item.parameters.general.dateend).format("DD/MM/YYYY") : "";
      return viewtoexport;
    });
    return (
      <>
        <SearchComponentView
          key="SearchComponentView"
          onFilter={onFilterTextView}
          onClear={handleClearView}
          filterText={filterTextView}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClearView}>
              <AddViewToCampaign
                onClick={handleClearView}
                refetch={refreshTableView}
                campaigngroup={groups}
                campaignid={campaign.id}
                points={points}
              />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClearView}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedviews || selectedviews.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterTextView, resetPaginationToggleView, views, selectedviews, points, campaign]);

  const handleSelectedRowsViewChange = (selection) => {
    setSelectedviews(selection.selectedRows);
  };

  return (
    <>
      <TabContext value={value} className={classes.root}>
        <div className={classes.demo2}>
          <AppBar
            position="static"
            className={classes.demo3}
            style={{ boxShadow: "none", shadowColor: "red" }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              scrollButtons="auto"
            >
              <StyledTab label="Paramètres généraux" value="0" />
              <StyledTab label="Equipements de la campagne" value="1" />
              <StyledTab label="Vues" value="2" />

            </StyledTabs>
            <Typography className={classes.padding} />
          </AppBar>
          <Divider variant="fullWidth" />
          <TabPanel value="0">
            <form className={classes.root}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={7} lg={7}>
                  <div>
                    <TextInput
                      isRequired
                      inputTitle={"Nom"}
                      textInput={name}
                      handleTextInputChange={handleNameChange}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={"Description"}
                      textInput={description}
                      handleTextInputChange={handleDescriptionChange}
                    />
                  </div>
                  <div>
                    <DateInput
                      inputTitle={"Date de début"}
                      dateInput={datebegin}
                      handleDateInputChange={handleDatebeginChange}
                    />
                  </div>
                  <div>
                    <DateInput
                      inputTitle={"Date de fin"}
                      dateInput={dateend}
                      handleDateInputChange={handleDateendChange}
                    />
                  </div>
                  {/* <div>
                    <CustomSelect
                      isRequired
                      inputTitle={"Statut"}
                      selectValue={status}
                      handleSelectValueChange={handleStatusChange}
                      data={statusData}
                    />
                  </div> */}
                  <div>
                    <TextInput
                      inputTitle={"Responsable de la campagne"}
                      textInput={incharge}
                      handleTextInputChange={handleInchargeChange}
                    />
                  </div>
                  <div>
                    <AutocompleteInput
                      isMultiple={false}
                      specialWidth={"97%"}
                      inputTitle={"Fichiers associés"}
                      selected={selectedDocuments()}
                      list={gedList}
                      handleChange={(_, newValue) =>
                        handleAssociatedfilesChange(newValue)
                      }
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip label={option.title} {...getTagProps({ index })} />
                        ))
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} lg={5}>
                  <div
                    className={classes.treeVisible}
                  >
                    <TreeLabel>Choix du périmètre</TreeLabel>
                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={handleGroupsChange}
                        userSelectedIds={groups}
                      />
                    </ImageList>
                  </div>
                </GridItem>
              </GridContainer>
            </form>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </TabPanel>
          <TabPanel value="1">
            <Container>
              <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                noDataComponent={<NoData>{"Aucun équipement"}</NoData>}
                noHeader={true}
                columns={equipmentscolumns}
                persistTableHead
                pagination
                subHeader
                data={filteredItems}
                onSelectedRowsChange={handleSelectedRowsChange}
                selectableRows={true}
                expandOnRowClicked={true}
                expandableRows={true}
                expandableRowDisabled={(row) => row.disabled}
                expandableRowsComponent={ExpandableComponent}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                  selectAllRowsItem: false,
                  selectAllRowsItemText: "Selectionner toutes les lignes",
                }}
                defaultPageSize={10}
                filterable={true}
                manual={true}
                paginationResetDefaultPage={resetPaginationToggle}
                subHeaderComponent={subHeaderComponentMemo}
              />
            </Container>
          </TabPanel>
          <TabPanel value="2">
            <Container>
              <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                noDataComponent={<NoData>{"Aucune vue"}</NoData>}
                noHeader={true}
                columns={viewscolumns}
                persistTableHead
                pagination
                subHeader
                data={filteredItemsView}
                onSelectedRowsChange={handleSelectedRowsViewChange}
                selectableRows={true}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                  selectAllRowsItem: false,
                  selectAllRowsItemText: "Selectionner toutes les lignes",
                }}
                defaultPageSize={10}
                filterable={true}
                manual={true}
                paginationResetDefaultPage={resetPaginationToggleView}
                subHeaderComponent={subHeaderComponentMemoView}
              />
            </Container>
          </TabPanel>
          {/* <TabPanel value="3">

          </TabPanel> */}
        </div>

      </TabContext>
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Edition d'un équipement
        </CustomDialogTitle>
        <DialogContent dividers>
          <EquipmentDialog
            closeModal={handleEditClose}
            refetch={refreshTable}
            equipment={currentequipment}
            mbmequipments={mbmequipments}
            equipments={equipments}
            setEquipments={setEquipments}
            campaigngroup={groups}
            campaignid={campaign.id}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditClosePoint}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openpoint}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClosePoint}>
          Edition de {currentpoint?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <PointDialog
            point={currentpoint}
            equipmentgroup={currentequipment?.parameters?.campaigngroup}
            closeModal={handleEditClosePoint}
            refetch={refreshTable}
            setNotification={setNotification}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloseView}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openview}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseView}>
          Edition de {currentview?.parameters?.general?.name}
        </CustomDialogTitle>

        <ViewEditionDialog
          currentView={currentview}
          closeModal={handleEditCloseView}
          refetch={refreshTableView}
          setNotification={setNotification}
          campaigngroup={groups}
          campaignid={campaign.id}
          points={points}
        />


      </Dialog>
      <CustomConfirmationDialog
        open={openExitConfirmation}
        handleClose={handleCloseConfirmation}
        handleExit={handleExitConfirmation}
        dialogContent={"Vous avez des changements non enregistrés, être vous sur de vouloir continuer?"}
        id={"draggable-dialog-title"}
      />
      <CustomYesNoDialog
        open={openExitConfirmationView}
        handleClose={handleCloseConfirmationView}
        handleExit={handleExitConfirmationView}
        dialogContent={"Certaines vues ont une date de fin antérieure à la nouvelle date de fin de la campagne. Voulez vous les mettre à jour?"}
        id={"draggable-dialog-title"}
      />
    </>
  );
}

export default CampaignEditionDialog;
